module.exports = __webpack_public_path__ + "img/2-place-medal.f923007c.svg";